import { render, staticRenderFns } from "./CompletitionCriteriaList.vue?vue&type=template&id=39545b50&"
import script from "./CompletitionCriteriaList.vue?vue&type=script&lang=js&"
export * from "./CompletitionCriteriaList.vue?vue&type=script&lang=js&"
import style0 from "./CompletitionCriteriaList.vue?vue&type=style&index=0&id=39545b50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports